import {
  type ApplicationValidationError,
  type DependencyValidationError,
  isGlMapHideOperation,
} from '@festina/configuration-general-types/configuration'

import type { ValidationErrorWithLocation } from '../../uiModels/errors/types'
import {
  getGlMapOperationFromDate,
  getGlMapOperationMappingId,
} from '../../uiModels/glMapOperations/helpers'
import type { GlMapOperation } from '../../uiModels/glMapOperations/types'
import type { OperationWithSourceInfo } from '../../uiModels/types'
import { ConfigurationItemOperationsWithErrors } from './ConfigurationItemOperationsWithErrors'
import type { OperationsListVariant } from './types'

type Props = {
  operations: OperationWithSourceInfo<GlMapOperation>[]
  errors: ValidationErrorWithLocation<
    ApplicationValidationError | DependencyValidationError
  >[]
  variant: OperationsListVariant
}

export const GlMapOperationsWithErrors = ({
  errors,
  operations,
  variant,
}: Props) => (
  <ConfigurationItemOperationsWithErrors
    operations={operations}
    errors={errors}
    variant={variant}
    itemIdFromOperation={(operation) =>
      getGlMapOperationMappingId(operation) ?? ''
    }
    link={{
      type: (operation, operationClass) =>
        (
          operation
            ? isGlMapHideOperation(operation)
            : operationClass === 'GlMapHideOperation'
        )
          ? 'hideGlMap'
          : 'glMap',
      fromDate: getGlMapOperationFromDate,
    }}
  />
)
